import styled, { css } from 'styled-components'
import { Link } from 'gatsby'

import pxToRem from '../../utils/pxToRem'
import ButtonVariantEnum from '../../enums/ButtonVariant'

const buttonsVariants = {
  [ButtonVariantEnum.primary]: css`
    border: ${({ theme }) =>
      `${pxToRem(2)} solid ${theme.colors.unique.transparent}`};
    padding: ${pxToRem(15.5)} ${pxToRem(25)};
    background-color: ${({ theme }) => theme.colors.primary.lime};

    &:disabled {
      border: ${({ theme }) =>
        `${pxToRem(2)} solid ${theme.colors.unique.transparent}`};
      background-color: ${({ theme }) => theme.colors.primary.grey};
      color: ${({ theme }) => theme.colors.unique.white};
    }

    &:hover {
      border: ${({ theme }) =>
        `${pxToRem(2)} solid ${theme.colors.primary.lime}`};
      background-color: ${({ disabled, theme }) => {
        if (disabled) {
          return 'none'
        }
        return theme.colors.unique.white
      }};
    }
  `,
  [ButtonVariantEnum.secondary]: css`
    border: ${({ theme }) =>
      `${pxToRem(2)} solid ${theme.colors.primary.blue}`};
    padding: ${pxToRem(15.5)} ${pxToRem(25)};
    background-color: ${({ theme }) => theme.colors.unique.white};

    &:disabled {
      border: ${({ theme }) =>
        `${pxToRem(2)} solid ${theme.colors.primary.grey}`};
      background-color: ${({ theme }) => theme.colors.unique.white};
      color: ${({ theme }) => theme.colors.unique.white};
    }

    &:hover {
      border: ${({ theme }) =>
        `${pxToRem(2)} solid ${theme.colors.unique.transparent}`};
      background-color: ${({ disabled, theme }) => {
        if (disabled) {
          return 'none'
        }
        return theme.colors.primary.blue
      }};
    }
  `,
  [ButtonVariantEnum.tertiary]: css`
    margin: ${pxToRem(15)} ${pxToRem(4)};
    border: ${({ theme }) =>
      `${pxToRem(2)} solid ${theme.colors.unique.transparent}`};
    border-radius: 0;
    padding: ${pxToRem(5)} 0;
    background-color: ${({ theme }) => theme.colors.unique.transparent};
    &:hover {
      border-bottom: ${({ theme }) =>
        `${pxToRem(2)} solid ${theme.colors.primary.blue}`};
    }
  `,
  [ButtonVariantEnum.quaternary]: css`
    border: ${({ theme }) =>
      `${pxToRem(2)} solid ${theme.colors.primary.blue}`};
    padding: ${pxToRem(15.5)} ${pxToRem(25)};
    background-color: ${({ theme }) => theme.colors.unique.white};

    &:disabled {
      border: ${({ theme }) =>
        `${pxToRem(2)} solid ${theme.colors.primary.grey}`};
      background-color: ${({ theme }) => theme.colors.unique.white};
      color: ${({ theme }) => theme.colors.unique.white};
    }

    &:hover {
      border: ${({ theme }) =>
        `${pxToRem(2)} solid ${theme.colors.unique.transparent}`};
      color: ${({ theme }) => theme.colors.unique.white};
      background-color: ${({ disabled, theme }) => {
        if (disabled) {
          return 'none'
        }
        return theme.colors.unique.black
      }};
    }
  `,
  [ButtonVariantEnum.quinary]: css`
    margin: ${pxToRem(15)} ${pxToRem(4)};
    border: ${({ theme }) =>
      `${pxToRem(2)} solid ${theme.colors.unique.transparent}`};
    border-radius: 0;
    padding: ${pxToRem(5)} 0;
    background-color: ${({ theme }) => theme.colors.unique.transparent};
  `,
}

export const StyledButtonComponent = css`
  align-items: center;
  display: flex;
  transition: 0.2s all ease;
  border-radius: ${pxToRem(5)};
  width: fit-content;
  cursor: ${({ disabled }) => !disabled && 'pointer'};
  font-size: ${({ theme }) => theme.fonts.sizes.button};
  line-height: ${({ theme }) => theme.fonts.lineHeight.button};
  font-weight: ${({ theme }) => theme.fonts.weight.bold};
  color: ${({ theme }) => theme.colors.unique.black};
  ${({ $variant }) =>
    ($variant && buttonsVariants[$variant]) ||
    buttonsVariants[ButtonVariantEnum.tertiary]}
`

export const StyledButton = styled.button`
  ${StyledButtonComponent};
`

export const StyledInternalLink = styled(Link)`
  ${StyledButtonComponent};
`

export const StyledExternalLink = styled.a`
  ${StyledButtonComponent};
`
